<div id="mauticform_wrapper_concluircadastro2" class="mauticform_wrapper">
    <form autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=20" 
    id="mauticform_concluircadastro2" data-mautic-form="concluircadastro2" enctype="multipart/form-data" #form>
        <div class="mauticform-error" id="mauticform_concluircadastro2_error"></div>
        <div class="mauticform-message" id="mauticform_concluircadastro2_message"></div>
        <div class="mauticform-innerform">

            
          <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

            <div id="mauticform_concluircadastro2_email" data-validate="email" data-validation-type="email" class="mauticform-row mauticform-email mauticform-field-1 mauticform-required">
                <input id="mauticform_input_concluircadastro2_email" name="mauticform[email]" class="mauticform-input"
                [value]="formData.email" type="email">
            </div>

            <div id="mauticform_concluircadastro2_termo_aceito" data-validate="termo_aceito" data-validation-type="text" class="mauticform-row mauticform-text mauticform-field-2 mauticform-required">
                <input id="mauticform_input_concluircadastro2_termo_aceito" name="mauticform[termo_aceito]" class="mauticform-input"
                [value]="formData.acceptTerm" type="text">
            </div>

            <div id="mauticform_concluircadastro2_sinatura_escolhida" data-validate="sinatura_escolhida" data-validation-type="text" class="mauticform-row mauticform-text mauticform-field-3 mauticform-required">
                <input id="mauticform_input_concluircadastro2_sinatura_escolhida" name="mauticform[sinatura_escolhida]" class="mauticform-input"
                [value]="formData.planSignature" type="text">
            </div>

            <div id="mauticform_concluircadastro2_plano_escolhido" class="mauticform-row mauticform-text mauticform-field-4">
                <input id="mauticform_input_concluircadastro2_plano_escolhido" name="mauticform[plano_escolhido]" class="mauticform-input" 
                [value]="formData.planCode" type="text">
            </div>

            <div id="mauticform_concluircadastro2_contrato_aceito" data-validate="contrato_aceito" data-validation-type="text" class="mauticform-row mauticform-text mauticform-field-5 mauticform-required">
                <input id="mauticform_input_concluircadastro2_contrato_aceito" name="mauticform[contrato_aceito]" class="mauticform-input" 
                [value]="formData.acceptContract" type="text">
            </div>

            <div id="mauticform_concluircadastro2_submit" class="mauticform-row mauticform-button-wrapper mauticform-field-6">
                <button type="submit" name="mauticform[submit]" id="mauticform_input_concluircadastro2_submit" value="" class="mauticform-button btn btn-default">Submit</button>
            </div>
            </div>
        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_concluircadastro2_id" value="20">
        <input type="hidden" name="mauticform[return]" id="mauticform_concluircadastro2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_concluircadastro2_name" value="concluircadastro2">
 
        </form>
</div>
